/* NIBBLE & NABBLE 2.0 — CART JS: fly-to-cart, states, shipping bar, toasts */
(function () {
  'use strict';

  var itemsEl = document.getElementById('nn-cart-items');
  var totalEl = document.getElementById('nn-cart-total');
  var shipEl = document.getElementById('nn-ship');
  var drawer = document.getElementById('nn-cart-drawer');
  var threshold = drawer ? parseInt(drawer.dataset.shipThreshold || '0', 10) * 100 : 0;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  /* ── Toasts ── */
  function toast(msg, isError) {
    var wrap = document.getElementById('nn-toasts');
    if (!wrap) return;
    var t = document.createElement('div');
    t.className = 'nn-toast' + (isError ? ' nn-toast--error' : '');
    t.textContent = msg;
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 350); }, 3000);
  }

  function renderCount(n) {
    document.querySelectorAll('.nn-nav__cart-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  function renderShip(total) {
    if (!shipEl || !threshold) return;
    var left = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    if (left > 0) {
      shipEl.classList.remove('nn-ship--done');
      shipEl.innerHTML = '<p class="nn-ship__label">You\u2019re <strong>' + money(left) + '</strong> away from free shipping</p><div class="nn-ship__track"><div class="nn-ship__fill"></div></div>';
    } else {
      shipEl.classList.add('nn-ship--done');
      shipEl.innerHTML = '<p class="nn-ship__label">\uD83C\uDF89 You\u2019ve unlocked free shipping!</p><div class="nn-ship__track"><div class="nn-ship__fill"></div></div>';
    }
    requestAnimationFrame(function () {
      var fill = shipEl.querySelector('.nn-ship__fill');
      if (fill) fill.style.width = pct + '%';
    });
  }

  function renderDrawer(cart) {
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div style="text-align:center;padding:3rem 1rem;color:var(--nn-mid);"><p style="font-family:var(--font-display);font-size:1.25rem;font-weight:600;margin-bottom:.5rem;">Your cart is empty</p><p style="font-size:.875rem;">Add some Nibble &amp; Nabble to your life.</p></div>';
      if (totalEl) totalEl.innerHTML = '';
      renderShip(0);
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (i) {
      return '<div class="nn-drawer-line" style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--nn-border);">' +
        '<div style="width:64px;height:64px;border-radius:8px;overflow:hidden;flex-shrink:0;background:var(--nn-cream);"><img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:cover;"></div>' +
        '<div style="flex:1;min-width:0;"><p style="font-family:var(--font-display);font-weight:600;font-size:.9rem;margin-bottom:.25rem;">' + i.product_title + '</p>' +
        '<div style="display:flex;align-items:center;gap:.5rem;margin-top:.5rem;">' +
        '<button data-d-qty="' + i.key + '" data-delta="-1" data-cur="' + i.quantity + '" style="width:26px;height:26px;border-radius:50%;border:1.5px solid var(--nn-border);background:transparent;cursor:pointer;">-</button>' +
        '<span style="font-weight:600;min-width:18px;text-align:center;">' + i.quantity + '</span>' +
        '<button data-d-qty="' + i.key + '" data-delta="1" data-cur="' + i.quantity + '" style="width:26px;height:26px;border-radius:50%;border:1.5px solid var(--nn-border);background:transparent;cursor:pointer;">+</button>' +
        '<span style="margin-left:auto;font-family:var(--font-display);font-weight:700;color:var(--nn-orange);">' + money(i.line_price) + '</span></div></div>' +
        '<button data-d-remove="' + i.key + '" style="align-self:flex-start;color:var(--nn-mid);font-size:1.1rem;" aria-label="Remove">&times;</button></div>';
    }).join('');
    if (totalEl) {
      totalEl.innerHTML = '<div style="display:flex;justify-content:space-between;margin-bottom:1rem;"><span style="font-family:var(--font-display);font-size:1.1rem;font-weight:600;">Subtotal</span><span id="nn-subtotal" style="font-family:var(--font-display);font-size:1.2rem;font-weight:700;color:var(--nn-orange);">' + money(cart.total_price) + '</span></div><a href="/checkout" class="nn-btn nn-btn-primary nn-btn-full" style="padding:1rem;">Checkout</a><a href="/cart" style="display:block;text-align:center;margin-top:.75rem;font-size:.875rem;color:var(--nn-mid);">View Cart</a>';
    }
    renderShip(cart.total_price);
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCount(cart.item_count); renderDrawer(cart); return cart;
    });
  }

  /* ── Fly-to-cart ── */
  function flyToCart(fromEl) {
    try {
      var img = fromEl && (fromEl.closest('.nn-product-card, .nn-product') || document).querySelector('img');
      var cartBtn = document.getElementById('nn-cart-trigger');
      if (!img || !cartBtn) return;
      var a = img.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
      var fly = img.cloneNode();
      fly.className = 'nn-fly-img';
      fly.style.left = (a.left + a.width / 2 - 36) + 'px';
      fly.style.top = (a.top + a.height / 2 - 36) + 'px';
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
        var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
        fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.15)';
        fly.style.opacity = '0.4';
      });
      setTimeout(function () { fly.remove(); }, 850);
    } catch (e) { /* cosmetic only */ }
  }

  function addItem(fd, btn) {
    if (btn) { btn.classList.add('is-loading'); }
    return fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          var prev = btn.textContent; btn.textContent = 'Added \u2713';
          setTimeout(function () { btn.classList.remove('is-success'); btn.textContent = prev; }, 1600);
          flyToCart(btn);
        }
        return refresh();
      })
      .then(function () {
        setTimeout(function () { window.NibbleNabble && window.NibbleNabble.openCart(); }, 500);
      })
      .catch(function (e) {
        if (btn) btn.classList.remove('is-loading');
        toast(e.message || 'Could not add to cart', true);
      });
  }

  function updateItem(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { return refresh(); })
      .catch(function () { toast('Cart update failed', true); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"], form.nn-card-atc-form');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    addItem(new FormData(form), e.submitter || form.querySelector('[name="add"]'));
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-d-remove]');
    var qty = e.target.closest('[data-d-qty]');
    var cartRm = e.target.closest('[data-cart-remove]');
    var cartQty = e.target.closest('[data-cart-qty]');
    if (rm) { updateItem(rm.dataset.dRemove, 0).then(function () { toast('Removed from cart'); }); }
    if (qty) { var c = parseInt(qty.dataset.cur, 10) || 1, d = parseInt(qty.dataset.delta, 10); updateItem(qty.dataset.dQty, Math.max(0, c + d)); }
    if (cartRm) { updateItem(cartRm.dataset.cartRemove, 0).then(function () { location.reload(); }); }
    if (cartQty) { var cc = parseInt(cartQty.dataset.current, 10) || 1, dd = parseInt(cartQty.dataset.delta, 10); updateItem(cartQty.dataset.cartQty, Math.max(0, cc + dd)).then(function () { location.reload(); }); }
  });

  window.NibbleNabble = window.NibbleNabble || {};
  window.NibbleNabble.refreshCart = refresh;
  window.NibbleNabble.toast = toast;

  if (shipEl) refresh();
})();
